// The one canonical class string for form controls (text inputs, selects, number
// inputs) so they share border, height, padding, radius and focus styling.
// The phone-sizing block in index.css additionally forces a 44px min-height and a
// 16px font < 640px (which also stops iOS focus-zoom); do not duplicate that here.
export const CONTROL_CLASS =
  "rounded-md border border-gray-300 dark:border-gray-700 " +
  "bg-white dark:bg-gray-800 px-3 py-2 text-sm " +
  "text-gray-900 dark:text-gray-100 " +
  "focus:outline-none focus:border-(--accent) focus:ring-1 focus:ring-(--accent)";

// Compact inline variant - e.g. a unit selector sitting next to a label in a
// single row (Preferences height/weight/fluid unit pickers).
export const CONTROL_CLASS_DENSE =
  "rounded-md border border-gray-300 dark:border-gray-700 " +
  "bg-white dark:bg-gray-800 px-2 py-0.5 text-xs " +
  "text-gray-900 dark:text-gray-100";
